import { render } from "./Raccolta.vue?vue&type=template&id=5f5b323f"
import script from "./Raccolta.vue?vue&type=script&lang=js"
export * from "./Raccolta.vue?vue&type=script&lang=js"

import "./Raccolta.vue?vue&type=style&index=0&id=5f5b323f&lang=css"

import exportComponent from "C:\\Users\\utente\\Documents\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__